// extracted by mini-css-extract-plugin
module.exports = {"authorize__wrapper":"AuthorizeBtn_authorize__wrapper__2kyoi","authorize__btn":"AuthorizeBtn_authorize__btn__aVV26"};